import { FragmentSerializer } from "./FragmentSerializer";
import FootballState from "../../../../../sports/football/state/football-state";
import TeamSide from "../../../../../sports/football/enums/team-side";

export class SpotFragmentSerializer extends FragmentSerializer {
    isStartOfFirstOrThirdPeriod(fragment, play, serializationContext) {
        return (
            serializationContext.isFirstPeriodPlay &&
            fragment.associatedState === FootballState.AddPlay &&
            [1, 3].some((p) => p === play.period)
        );
    }

    isContextUpdate(fragment) {
        return fragment.associatedState === FootballState.UpdateContext;
    }

    applicable(fragment, play, serializationContext) {
        return (
            this.isStartOfFirstOrThirdPeriod(
                fragment,
                play,
                serializationContext
            ) ||
            (serializationContext.isSpotUpdate &&
                this.isContextUpdate(fragment))
        );
    }

    getRawFragment(play, serializationContext, fragment) {
        const { gameContext } = serializationContext;
        let { fieldPosition, triggerDrive, homeTeamHasPossession, homeTeamId } =
            gameContext;
        let teamSide = homeTeamHasPossession ? TeamSide.Home : TeamSide.Visitor;
        const startDrive = triggerDrive ? "Y" : "N"; // TODO: make sure the triggerDrive flag correctly indicates a drive is being started.

        if (this.isContextUpdate(fragment)) {
            const { values } = fragment;
            fieldPosition = values.fieldPosition;
            teamSide =
                values.teamPossession === homeTeamId
                    ? TeamSide.Home
                    : TeamSide.Visitor;
        }

        const values = [
            teamSide,
            this.resolveFormattedFieldPosition({ gameContext }, fieldPosition),
            startDrive
        ];

        return `SPOT:${values.join()}`;
    }
}
